// Selectors
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import {
    selectUserRoleCodes,
    makeSelectUsersMeValue
} from 'services/usersMe/selectors';
import { selectReEntryWarning } from 'services/reEntryWarning/selectors';
import { makeSelectLoading } from 'services/loading/selectors';

// Constants
import { ADMIN, MANAGER } from 'components/RoleGate/constants';
import { RE_ENTRY_WARNING_LOAD_NAMESPACE } from 'services/reEntryWarning/constants';

export const selectUserHasWarningPass = createDeepEqualSelector(
    [makeSelectUsersMeValue('isSuperAdmin'), selectUserRoleCodes],
    (isSuperAdmin: boolean, userRoleCodes?: string[]): boolean =>
        isSuperAdmin ||
        (!!userRoleCodes &&
            [ADMIN, MANAGER].some((role) => userRoleCodes.includes(role)))
);

export const selectWarningDisabled = createDeepEqualSelector(
    [
        selectUserHasWarningPass,
        selectReEntryWarning,
        makeSelectLoading(RE_ENTRY_WARNING_LOAD_NAMESPACE)
    ],
    (
        hasWarningPass: boolean,
        isWarning: boolean,
        isLoading: boolean
    ): boolean => !hasWarningPass && (isWarning || isLoading)
);

export const makeSelectWarningDisabled = (): typeof selectWarningDisabled =>
    selectWarningDisabled;
